
module.exports = [
  {
    id: 0,
    label: `Hors-service`,
    icon: `remove_circle`,
  },
  {
    id: 1,
    label: `Mauvais état`,
    icon: `thunderstorm`,
  },
  {
    id: 2,
    label: `Bon état`,
    icon: `thumb_up`,
  },
  {
    id: 3,
    label: `Très bon état`,
    icon: `check_circle`,
  },
  {
    id: 4,
    label: `Neuf`,
    icon: `stars`,
  },
];
